import React from 'react';
import { ReactComponent as Doc } from 'assets/icons/file.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { Attachment } from 'graphql/generated/hasura';

type AttachFileType = Omit<Attachment, 'url' | 'language' | 'creation'>;

interface AttachFileProps extends AttachFileType {
  onDelete?: () => void;
}

const AttachFile: React.FC<AttachFileProps> = ({ title, onDelete }) => {
  return (
    <div className="relative z-10 bg-base-content flex flex-row justify-between border border-gray-opacity-15 desktop:rounded-md rounded desktop:items-center w-full gap-2.5 py-0.5 px-1.5">
      <div
        className="absolute cursor-pointer -right-2 -top-2 p-0.5 rounded-full bg-neutral-800"
        onClick={onDelete}
      >
        <Close className="w-3 h-3 stroke-white" />
      </div>
      <div className="flex items-center desktop:gap-2.5">
        <div className="text-black">
          <Doc className={'w-4 h-4 max-desktop:hidden'} />
        </div>
        <div className="flex flex-col text-neutral-800 font-semibold">
          <div className="truncate text-sm desktop:max-w-[120px] max-w-[80px]">
            {title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachFile;
